import React from 'react';
import Modal from 'react-modal';

interface ConfirmationModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  title: string;
  message: string;
  onConfirm?: () => void;
  confirmButtonText?: string;
  cancelButtonText?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onRequestClose,
  title,
  message,
  onConfirm,
  confirmButtonText = 'Ok',
  cancelButtonText,
}) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    style={{
      content: {
        position: 'relative',
        top: '40%',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        margin: 'auto',
        background: '#fff',
        padding: '20px',
        borderRadius: '10px',
        maxWidth: '400px',
        width: '80%',
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
        zIndex: 1001,
        textAlign: 'center'
      },
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        zIndex: 1000,
      },
    }}
  >
    <h2 style={{ fontSize: '20px', marginBottom: '15px' }}>{title}</h2>
    <p style={{ fontSize: '16px', marginBottom: '20px', whiteSpace: 'pre-line' }}>{message}</p> { }
    <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
      <button
        onClick={onConfirm || onRequestClose}
        style={{
          padding: '10px 20px',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '16px',
          backgroundColor: '#28a745',
          color: 'white',
          transition: 'background-color 0.3s ease',
          maxWidth: '75px',
          width: '100%',
        }}
        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#218838')}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#28a745')}
      >
        {confirmButtonText}
      </button>
      {cancelButtonText && (
        <button
          onClick={onRequestClose}
          style={{
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            backgroundColor: '#d9534f',
            color: 'white',
            transition: 'background-color 0.3s ease',
            maxWidth: '75px',
            width: '100%',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#c9302c')}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#d9534f')}
        >
          {cancelButtonText}
        </button>
      )}
    </div>
  </Modal>
);

export default ConfirmationModal;
